import React from 'react'
import ReactDOM from 'react-dom/client'
import InvoiceApp from './App.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <InvoiceApp />
  </React.StrictMode>,
)
